interface CheckboxProps {
  label?: string;
  name: string;
  value: string | boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Checkbox = (props: CheckboxProps) => {
  const { label, name, value, onChange } = props;
  return (
    <label
      id="w-node-_74b0d489-7826-3f59-77af-ecc21f9a8fd4-8b21f121"
      className="w-checkbox"
    >
      <input
        type="checkbox"
        id={name}
        name={name}
        checked={Boolean(value)}
        value={typeof value !== "boolean" ? value : ""}
        onChange={onChange}
        className="w-checkbox-input"
      />
      <span className="w-form-label">{label}</span>
    </label>
  );
};

export default Checkbox;
